<template>
  <v-card outlined class="rounded-lg">
    <v-card-title>
      Sessions
    </v-card-title>
    <v-card-text>
      <v-autocomplete
        v-model="selectedMapId"
        :items="mapIds"
        :hint="createdAtHint"
        label="Map ID"
        filled
        dense
        persistent-hint
        item-text="alias"
        item-value="mapId"
        hide-detailse="auto"
      />
      <keep-alive>
        <session-filters
          ref="sessionFilters"
          :map-id="selectedMapId"
          @update="updateFilters"
        />
      </keep-alive>
    </v-card-text>
    <v-card-actions>
      <v-btn
        text
        color="red"
        :loading="loading"
        @click="deleteSession"
      >
        DELETE
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import SessionFilters from '../../../components/filters/Telemetry/SessionFilters.vue'
export default {
  components: {
    SessionFilters
  },
  data () {
    return {
      mapIds: [],
      builds: [],
      loading: false,
      selectedMapId: null,
      selectedData: {
        build_id: null,
        user_id: null,
        session_id: null,
      }
    }
  },
  async created () {
    const { data } = await this.$axios.get(this.$store.getters.projectPath + '/configs/multi-map')
    .catch(error => ({ data: { err: true, message: error.response.data } }))

    if (data.err) {
      this.$toasted.error(data.message)
    } else {
      this.mapIds = data
      if (data.length) {
        this.selectedMapId = data[0].mapId
      }
    }
  },
  computed: {
    createdAtHint () {
      const val = this.mapIds.find(mapId => mapId.mapId === this.selectedMapId)
      if (val) {
        return val.createdAt
      } else {
        return ''
      }
    }
  },
  watch: {
    async selectedMapId () {
      this.selectedTimelineData = {
        build_id: null,
        user_id: null,
        session_id: null
      }
    }
  },
  methods: {
    updateFilters (data) {
      this.selectedData = { ...this.selectedData, ...data }
    },
    async deleteSession () {
      this.loading = true

      const { data } = await this.$axios.delete(
        this.$store.getters.projectPath +
        '/telemetry/session/' +
        this.selectedData.build_id +
        '/' + this.selectedData.user_id +
        '/' + this.selectedData.session_id
      )
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.$toasted.success('Success')
        await this.$refs.sessionFilters.getDataForFilters(this.selectedData.user_id)
      }
      this.loading = false
    }
  }
}
</script>